import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPaperclip12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconPaperclip12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.393 2.384C3.162 2.616 3 2.99 3 3.55v4.08C3 8.976 4.05 10 5.5 10S8 8.977 8 7.628V3.55h1v4.08C9 9.573 7.458 11 5.5 11S2 9.574 2 7.628V3.55c0-.754.222-1.406.684-1.87C3.145 1.215 3.785 1 4.5 1s1.355.215 1.816.679S7 2.795 7 3.549V7c0 .411-.026.898-.228 1.289-.109.209-.27.397-.5.528A1.54 1.54 0 0 1 5.5 9a1.55 1.55 0 0 1-.771-.183 1.26 1.26 0 0 1-.5-.528C4.025 7.899 4 7.41 4 7V3.511h1V7c0 .412.037.676.116.83a.26.26 0 0 0 .105.116A.56.56 0 0 0 5.5 8c.155 0 .236-.03.279-.054a.26.26 0 0 0 .105-.117C5.964 7.676 6 7.412 6 7V3.55c0-.561-.162-.934-.393-1.166C5.377 2.152 5.017 2 4.5 2s-.877.152-1.107.384M4.5 3.01a.5.5 0 0 1 .5.5H4a.5.5 0 0 1 .5-.5m4 .04a.5.5 0 0 1 .5.5H8a.5.5 0 0 1 .5-.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPaperclip12);
